//================================================================
//  Tab: Support
//================================================================

//  Purpose: This tab displays all 'Support' of an Application

//  Example:
//    <Support></Support>    

//================================================================

//Libraries
import React, { useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

//Contexts
import { GetUser } from '../../../../../Library/GlobalContexts';

//Components
import PageComponent from '../../../../../Components/PageComponent/PageComponent';
import LiveField from '../../../../../Components/LiveField/LiveField';

//Functions
import DocumentListener from '../../../../../Library/DocumentListener';

//Images


export default function Support() {

  //------------------------------------------------------
  //  useContext & React Router
  //------------------------------------------------------

  const getUser = useContext(GetUser);
  const params = useParams();

  //------------------------------------------------------
  //  useStates
  //------------------------------------------------------

  // Used to save page status > 'pending', 'onload', 'error-invalid', 'error-fatal'
  const [pageStatus, setPageStatus] = useState('pending');

  // Holds the application document from 
  const [applicationDoc, setApplicationDoc] = useState();

  //------------------------------------------------------
  //  Functions
  //------------------------------------------------------

  //------------------------------------------------------
  //  useEffects
  //------------------------------------------------------

  // Query Listener
  // - Get all Overview with the status of 'Active'
  useEffect(() => {

    const applicationId = params.id;

    if (applicationId === '') return;
    if (applicationId === null) return;

    function onLoadChange(document) {

      if (document === undefined) return setPageStatus('forbidden');

      setApplicationDoc(document);
      setPageStatus('onload')
      
    }

    function onError(error) {

      console.log(error);
      setPageStatus('error-fatal');

    }

    const unsubscribe = DocumentListener('applications', applicationId, onLoadChange, onLoadChange, onError);

    return () => {
      unsubscribe();
    };

    // eslint-disable-next-line
  }, [getUser]);

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (
    <PageComponent
      status={pageStatus}
      body={
        <div className='flex flex-col w-[50%] px-[20px]'>

          {/* Visible in JSM */}
          <LiveField
            type='choice'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'visibleinjsm'}
            label={<label className='font-medium'>Visible in JSM</label>}
            defaultValue={applicationDoc?.visibleinjsm}
            options={[
              'Yes',
              'No',
            ]}
          ></LiveField>

          {/* Supported By */}
          <LiveField
            type='choice'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'supportedby'}
            label={<label className='font-medium'>Supported By</label>}
            defaultValue={applicationDoc?.supportedby}
            options={[
              'Accenture',
              'Business',
              'Deloitte',
              'Lendlease - Internal',
              'Lendlease - Digital',
              'Digitality',
              'Hype & Dexter',
              'DataProwess',
              'Other',
            ]}
          ></LiveField>

          {/* Support Level (Internal) */}
          <LiveField
            type='multiselect'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'supportlevelinternal'}
            label={<label className='font-medium'>Support Level (Internal)</label>}
            defaultValue={applicationDoc?.supportlevelinternal}
            options={[
              'Level 1',
              'Level 2',
              'Level 3',
              'N/A',
            ]}
          ></LiveField>

          {/* Support Level (External) */}
          <LiveField
            type='multiselect'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'supportlevelexternal'}
            label={<label className='font-medium'>Support Level (External)</label>}
            defaultValue={applicationDoc?.supportlevelexternal}
            options={[
              'Level 1',
              'Level 2',
              'Level 3',
              'N/A',
            ]}
          ></LiveField>

          {/* Support Assignment Group */}
          <LiveField
            type='text'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'supportassignmentgroup'}
            label={<label className='font-medium'>Support Assignment Group</label>}
            defaultValue={applicationDoc?.supportassignmentgroup}
            placeholder={'JSM Assignment Group for routing of tickets'}
          ></LiveField>

          {/* Support Renewal Date */}
          <LiveField
            type='date-string'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'supportrenewaldate'}
            label={<label className='font-medium'>Support Renewal Date</label>}
            defaultValue={applicationDoc?.supportrenewaldate}
          ></LiveField>

          {/* Workflows */}
          <LiveField
            type='multiline'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'workflows'}
            label={<label className='font-medium'>Workflows</label>}
            defaultValue={applicationDoc?.workflows}
            placeholder={'Existing Workflows?'}
          ></LiveField>

          {/* Frequency - User Access Review */}
          <LiveField
            type='choice'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'useraccessreview'}
            label={<label className='font-medium'>Frequency - User Access Review</label>}
            defaultValue={applicationDoc?.useraccessreview}
            options={[
              'Monthly',
              'Quarterly',
              'Semi-Annual',
              'Annual',
            ]}
          ></LiveField>

          {/* Frequency - Prod Backup */}
          <LiveField
            type='choice'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'prodbackup'}
            label={<label className='font-medium'>Frequency - Prod Backup</label>}
            defaultValue={applicationDoc?.prodbackup}
            options={[
              'Daily',
              'Weekly',
              'Monthly',
              'Quarterly',
              'Semi-Annual',
              'Annual',
            ]}
          ></LiveField>

          {/* Frequency - SLA Reporting */}
          <LiveField
            type='choice'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'slareporting'}
            label={<label className='font-medium'>Frequency - SLA Reporting</label>}
            defaultValue={applicationDoc?.slareporting}
            options={[
              'Monthly',
              'Quarterly',
              'Semi-Annual',
              'Annual',
            ]}
          ></LiveField>

          {/* Support DL */}
          <LiveField
            type='text'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'supportdl'}
            label={<label className='font-medium'>Support DL</label>}
            defaultValue={applicationDoc?.supportdl}
            placeholder={'Distribution Email for support'}
          ></LiveField>

          {/* Data Classification */}
          <LiveField
            type='choice'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'dataclassification'}
            label={<label className='font-medium'>Data Classification</label>}
            defaultValue={applicationDoc?.dataclassification}
            options={[
              'Public',
              'Internal',
              'Confidential',
              'Restricted',
            ]}
          ></LiveField>

          {/* Decommissioned Date */}
          <LiveField
            type='date-string'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'decommissiondata.decommissiondate'}
            label={<label className='font-medium'>Decommissioned Date</label>}
            defaultValue={applicationDoc?.decommissiondata?.decommissiondate}
          ></LiveField>

          {/* Decommission Data Retention */}
          <LiveField
            type='text'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'decommissiondata.dataretention'}
            label={<label className='font-medium'>Decommission Data Retention</label>}
            defaultValue={applicationDoc?.decommissiondata?.dataretention}
            placeholder={'How long will the data need to be retained after decommission'}
          ></LiveField>

          {/* Decommission Data Classification */}
          <LiveField
            type='text'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'decommissiondata.dataclassification'}
            label={<label className='font-medium'>Decommission Data Classification</label>}
            defaultValue={applicationDoc?.decommissiondata?.dataclassification}
            placeholder={'Where is the data stored after decommission'}
          ></LiveField>

          {/* Decommissioned Data Location */}
          <LiveField
            type='text'
            collectionid='applications'
            documentid={applicationDoc?.applicationid}
            fieldpath={'decommissiondata.datalocation'}
            label={<label className='font-medium'>Decommissioned Data Location</label>}
            defaultValue={applicationDoc?.decommissiondata?.datalocation}
            placeholder={'Location where decomissioned data is hosted'}
          ></LiveField>

        </div>
      }
    ></PageComponent>
  )
}
